module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-20.3aab54e3.png";